<template>
    <PublicHeader />
    <section class="container">
      <div class="login">
        <h2 class="sm-fs-xl mb-20">Log in to your account</h2>
        <!-- Role Selection -->
        <div class="role-selection mt-10 mb-20">
          <label class="pdr-15">
            <input type="radio" name="role" value="P" v-model="credentials.role" />
            Participant
          </label>
          <label class="pdr-15">
            <input type="radio" name="role" value="L" v-model="credentials.role" />
            Local
          </label>
          <label class="pdr-15">
            <input type="radio" name="role" value="E" v-model="credentials.role" />
            Employer
          </label>
          <!-- <label>
            <input type="radio" name="role" value="A" v-model="credentials.role" />
            Admin
          </label> -->
        </div>
        <form id="login-form" @submit.prevent="login" method="POST">
          <div class="inputs-wrapper w-50 w-sm-100 sm-fs-base gap-0">
            <TextInput
              type="email"
              label="Email Address"
              placeholder="Email"
              :max="50"
              v-model:modelValue="credentials.email"
              :is-required="true"
              :error="errors?.email"
              :required="true"
              custom-class="w-100 mb-20"
            />
            <TextInput
              type="password"
              label="Password"
              placeholder="Password"
              v-model:modelValue="credentials.password"
              :is-required="true"
              :error="errors?.password"
              :required="true"
              custom-class="mb-20"
            />
            <small class="w-100 fw-light fs-sm mb-20">
              Minimum 8 characters, One Uppercase, One Lowercase, One Symbol and One Number
            </small>
            <p class="w-100 pdb-20 text-danger fs-sm" v-if="error">
              {{ error }}
            </p>
            <CheckBox label="Remember me" id="remember" :showLabel="true" className="text-x-large" />
          </div>

          <button type="submit" class="btn btn-primary w-sm-100 sm-fs-base" :disabled="loading">
            <span v-if="loading">Logging in...</span>
            <span v-else>Login</span>
          </button>
        </form>
      </div>
    </section>
    <PublicFooter />
  </template>

  <script lang="ts">
  import { ref, onMounted } from 'vue';
  import { useAuthStore } from '@/stores/auth';
  import axios, { AxiosError } from 'axios';
  import TextInput from '@components/form/TextInput.vue';
  import CheckBox from '@components/form/CheckBox.vue';
  import PublicHeader from '@components/PublicHeader.vue';
  import PublicFooter from '@components/PublicFooter.vue';

  export default {
    components: {
      TextInput,
      CheckBox,
      PublicHeader,
      PublicFooter
    },
    setup() {
      const authStore = useAuthStore();
      const error = ref('');
      // Updated credentials object to include the role parameter (default to "P")
      const credentials = ref({ email: '', password: '', role: 'P' });
      const loading = ref(false);
  
      const login = async () => {
        loading.value = true;
        error.value = '';
  
        try {
          await authStore.authenticateUser(credentials.value);
          loading.value = false;
        } catch (loginError: unknown) {
          loading.value = false;
  
          if (axios.isAxiosError(loginError)) {
            error.value = 'Login failed: ' + loginError.response?.data?.message;
          } else {
            error.value = 'An unknown error occurred';
          }
        }
      };
  
      onMounted(() => {
        authStore.logout();
        authStore.clearUserStore();
      });
  
      return { credentials, login, loading, error };
    },
  };
  </script>